import Header from "../driver/components/Header";
import Footer from "../driver/components/Footer";

const DriverLayout = ({ children }) => {

  return (<>
    <div className="DashboardMainBody">
      <Header />
      {children}
    </div>
    <Footer />
  </>);
};

export default DriverLayout;